import { ArrowRight } from 'lucide-react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { Reveal } from 'shared/components/motion/Reveal';
import { Button } from 'shared/components/ui/Button';
import { ARENA_OWNER_SIGNUP } from 'shared/constants/routes';

export function ArenaOwnerCtaSection() {
  return (
    <section className="px-4 pt-6">
      <Reveal className="relative mx-auto flex max-w-7xl flex-col items-start gap-5 overflow-hidden rounded-3xl bg-ink px-6 py-8 sm:flex-row sm:items-center sm:justify-between sm:px-10">
        <motion.div
          aria-hidden="true"
          className="pointer-events-none absolute -right-20 -top-20 h-72 w-72 rounded-full bg-primary/30 blur-3xl"
          animate={{ scale: [1, 1.25, 1], opacity: [0.6, 1, 0.6] }}
          transition={{ duration: 8, repeat: Infinity, ease: 'easeInOut' }}
        />
        <div className="relative">
          <span className="inline-flex items-center gap-2 rounded-full bg-surface/10 px-3 py-1 text-xs font-medium text-accent">
            Para donos de arena
          </span>
          <h2 className="mt-3 font-heading text-xl font-bold text-surface sm:text-2xl">
            Tem uma arena? Pare de anotar reserva no caderno.
          </h2>
          <p className="mt-2 max-w-md text-sm text-surface/70">
            Agenda online, cobrança automática e menos no-show. Cadastre sua unidade em poucos minutos.
          </p>
        </div>

        <Link to={ARENA_OWNER_SIGNUP} className="relative w-full sm:w-auto">
          <Button variant="ghost-inverse" className="w-full sm:w-auto">
            Cadastrar minha arena
            <ArrowRight className="h-4 w-4" aria-hidden="true" />
          </Button>
        </Link>
      </Reveal>
    </section>
  );
}
